module.exports = __webpack_public_path__ + "assets/img/img206.01e942d1.png";